import { TestConfig } from 'yup'
import isEmpty from 'lodash/isEmpty'

import { formatMoney } from '../../utils.ts'

export const isEmail: TestConfig<string | undefined> = {
  name: 'isEmail',
  test: (value) => (value ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/i.test(value) : true),
  message: 'Поле должно содержать email',
}

export const isPhoneNumber: TestConfig<string | undefined> = {
  name: 'isPhoneNumber',
  test: (value) => (value ? !!value.match(/^\d{10}$/g) : true),
  message: 'Поле должно содержать 10 символов номера телефона',
}

export const isLessOrEqual: (max: string | number | null) => TestConfig<string | number | undefined> = (
  max = 999999
) => {
  const maxAmount = max ?? 999999
  return {
    name: 'isLessThan',
    test: (value) => (!isEmpty(value) ? Number(value) <= Number(maxAmount) : true),
    message: `Значение не должно быть больше ${formatMoney(maxAmount)}`,
  }
}

export const isMoreOrEqual: (max: string | number | null) => TestConfig<string | number | undefined> = (min = 1) => {
  const minAmount = min ?? 1
  return {
    name: 'isMoreThan',
    test: (value) => (!isEmpty(value) ? Number(value) <= Number(minAmount) : true),
    message: `Значение должно быть больше ${formatMoney(minAmount)}`,
  }
}

export const isNotZero: TestConfig<string | number> = {
  name: 'isNotZero',
  test: (value) => Number(value) !== 0,
  message: 'Значение должно быть больше 0',
}

export const isNotMaxLength = (maxLength: number): TestConfig<string | undefined> => ({
  name: 'isNotMaxLength',
  test: (value) => (value?.length ?? 0) <= maxLength,
  message: `В поле может быть не более ${maxLength} символов`,
})

export const isWithinRange = (min: number, max: number): TestConfig<string | number | undefined> => ({
  name: 'isWithinRange',
  test: (value) => (!isEmpty(value) ? Number(value) >= min && Number(value) <= max : true),
  message: `Значение поля может быть от ${min} до ${max}`,
})
